import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import { LocalStorageServiceProvider } from '../../providers/local-storage-service/local-storage-service'
import { LoadingController } from 'ionic-angular';
import { Events } from 'ionic-angular';
import { PeriodicityFormatterProvider } from '../../providers/periodicity-formatter/periodicity-formatter';

export let PERIODIC_TRANSACTION_CREATED_EVENT = "transaction:created";

@Component({
    selector: 'page-periodic-transaction-form',
    templateUrl: 'periodic-transaction-form.html',
})
export class PeriodicTransactionAddPage {

    periodic_transaction = {
        next_execution: new Date().toISOString(),
        execution_period_str: ""
    }
    categories = []
    accounts = []
    periodicity = []

    user_id:String

    constructor(public navCtrl: NavController, public navParams: NavParams,
        public server: ServerProvider, public localStorage: LocalStorageServiceProvider,
        public loadingCtrl: LoadingController, public events: Events,
        public periodicity_formatter: PeriodicityFormatterProvider
    ) {

        this.categories = localStorage.getCategories();
        this.periodicity = periodicity_formatter.getPeriod();

        this.user_id = this.navParams.get("user_id");

        server.getAccounts(this.user_id).subscribe(
            data => {
                this.accounts = data.json()
            },
            error => {

            }
        )
    }

    stringify(val){
        return JSON.stringify(val)
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad PeriodicTransactionFormPage');
    }

    save(transaction) {
        transaction.execution_period = JSON.parse(transaction.execution_period_str)

        this.server.createPeriodicTransaction(this.user_id, transaction.account_id, transaction)
        .subscribe(
            data=>{
                this.navCtrl.pop()
                this.events.publish(PERIODIC_TRANSACTION_CREATED_EVENT, data.json())
            },
            error=>{

            }
        )
    }

    abort() {
        this.navCtrl.pop()
    }
}



// WEBPACK FOOTER //
// ./src/pages/periodic-transaction-form/periodic-transaction-form-add.ts